import React from 'react'
import { Col } from 'antd'
import styled from 'styled-components'

type Props = {
  children?: React.ReactElement
  id?: string
  size?: 'sm' | 'lg'
  dataTestId?: string
}

export const CardFormat = ({
  children,
  id,
  size,
  dataTestId,
}: Props): React.ReactElement => {
  const isLarge = size === 'lg'

  return (
    <Col
      xs={24}
      sm={24}
      md={isLarge ? 12 : 6}
      lg={isLarge ? 12 : 6}
      xl={isLarge ? 12 : 6}
      id={id}
      data-testid={dataTestId || 'card-format'}
    >
      <InnerCard isLarge={isLarge}>{children}</InnerCard>
    </Col>
  )
}

const InnerCard = styled.div<{ isLarge?: boolean }>`
  background-color: ${({ theme }) => theme.color.neutral.color11};
  border-radius: 20px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 220px;
  padding: 24px 24px;
  margin-bottom: 24px;
`
